import { Cancel } from '@mui/icons-material';
import { AppBar, Box, Drawer, styled } from '@mui/material';

export const HeaderMobile = styled(AppBar)(({ theme }) => ({
  backgroundColor: theme.palette.primary.dark,
  padding: theme.spacing(8, 12),
  flex: 0,
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
}));

export const StyledLogo = styled('img')(() => ({
  width: 100,
  height: 35,
}));

export const StyledDrawer = styled(Drawer)(({ theme }) => ({
  '& .MuiDrawer-paper': { backgroundColor: theme.palette.primary.dark },
}));

export const CancelIcon = styled(Cancel)(({ theme }) => ({
  color: theme.palette.grey.A100,
}));

export const Offset = styled('div')(({ theme }) => theme.mixins.toolbar);

export const ContentContainer = styled(Box)(({ theme }) => ({
  flex: 1,
  height: '100%',
}));
